import { createPosthogBeforeSend } from '@/shared/utils/createPosthogBeforeSend.js';

// Loaded from theme/snippets/posthog.liquid as a plain, synchronous
// (non-module) <script src> BEFORE the inline posthog.init() call, so this
// global exists in time to be passed as `before_send` — no queuing, no
// race against the async SDK load. It only imports plain utility modules
// (no Vue, no shared deps with the app entries below), so Vite/Rollup emits
// it as a single self-contained file with no import/export syntax, safe to
// load without `type="module"`. See docs/posthog-error-tracking-plan.md §3.4/§3.7.
window.__fctPosthogBeforeSend = createPosthogBeforeSend();
